"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "DropdownContainer", {
    enumerable: true,
    get: function() {
        return DropdownContainer;
    }
});
const _react = /*#__PURE__*/ _interop_require_wildcard(require("react"));
const _Dropdown = require("./Dropdown");
const _DropdownMenu = require("./DropdownMenu/DropdownMenu");
const _Theme = require("../../contexts/Theme");
function _getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return (_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function _interop_require_wildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) {
        return obj;
    }
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") {
        return {
            default: obj
        };
    }
    var cache = _getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) {
        return cache.get(obj);
    }
    var newObj = {
        __proto__: null
    };
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj){
        if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
            var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
            if (desc && (desc.get || desc.set)) {
                Object.defineProperty(newObj, key, desc);
            } else {
                newObj[key] = obj[key];
            }
        }
    }
    newObj.default = obj;
    if (cache) {
        cache.set(obj, newObj);
    }
    return newObj;
}
const Inner = (param)=>{
    let { trigger, disableKeyboard, disabled } = param;
    const dropdown = (0, _react.useContext)(_Dropdown.DropdownContext);
    const handleClick = (e)=>{
        if (disabled !== null && disabled !== void 0 ? disabled : false) {
            return;
        }
        dropdown.setShow(!dropdown.show);
    };
    const handleKeyDown = (event)=>{
        if (disableKeyboard !== true) {
            switch(event.key.toLowerCase()){
                case " ":
                case "Enter":
                    event.preventDefault();
                    dropdown.setShow(!dropdown.show);
                    break;
                default:
                    break;
            }
        }
    };
    return /*#__PURE__*/ _react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/ _react.default.createElement("div", {
        ref: dropdown.reference,
        onClick: handleClick,
        onKeyDown: handleKeyDown
    }, trigger));
};
const DropdownContainer = (param)=>{
    let { children, placement = "bottom-start", onSelect, onClose, fontWeight, fixedHeader, width, mobileView, title, sameWidth, maxHeight, ...props } = param;
    const { isAdmin } = (0, _Theme.useTheme)();
    return /*#__PURE__*/ _react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/ _react.default.createElement(_Dropdown.Dropdown, {
        placement: placement,
        onSelect: onSelect,
        fontWeight: fontWeight !== null && fontWeight !== void 0 ? fontWeight : isAdmin ? "heavy" : "light",
        sameWidth: sameWidth,
        onClose: onClose,
        flip: true
    }, /*#__PURE__*/ _react.default.createElement(Inner, props), children != null && /*#__PURE__*/ _react.default.createElement(_DropdownMenu.DropdownMenu, {
        fixedHeader: fixedHeader,
        width: width,
        maxHeight: maxHeight,
        mobileView: mobileView,
        title: title
    }, children)));
};
DropdownContainer.displayName = "DropdownContainer";

//# sourceMappingURL=DropdownContainer.js.map